import styles from "./SingleChoiceQuestion.module.css";
import { useTranslation } from "react-i18next";
export default function SingleChoiceQuestion({
    details = {},
    value,
    onChange,
    name
}) {
    const { t } = useTranslation();

    const options = details.options || [];
    const textFields = details.textFields || [];
    const selected = value?.choice || null;
    const detailsMap = value?.details || {};

    const handleSelect = (opt) => {
        onChange({ choice: opt, details: { ...detailsMap } });
    };

    const handleDetailsChange = (opt, text) => {
        onChange({ choice: selected ?? "", details: { ...detailsMap, [opt]: text } });
    };


    return (
        <div className={styles.wrap}>
            {options.map((option, i) => {
                const optLabel = typeof option === 'object' && option !== null ? option.label : option;
                return (
                <div key={i + 1} className={styles.row} name={name}>
                    <label className={`${styles.optionLabel} ${selected === i + 1 ? styles.selected : ''}`}>
                        <input
                            type="radio"
                            className={styles.radio}
                            value={i + 1}
                            checked={selected === i + 1}
                            onChange={() => handleSelect(i + 1)}
                        />
                        <span>{optLabel}</span>
                    </label>
                    {textFields.includes(i + 1) && (
                        <input
                            type="text"
                            className={styles.detailsInput}
                            value={detailsMap[i + 1] || ""}
                            onChange={(e) => handleDetailsChange(i + 1, e.target.value)}
                            disabled={selected !== i + 1}
                            placeholder={selected === i + 1 ? t("placeholder.textField") : ""}
                        />
                    )}
                </div>
                );
            })}
        </div>
    );
}
